/**
 * @jsxRuntime classic
 * @jsx jsx
 */

export const emojiPlaceholderTestId: any = (shortName: string) => `emoji-placeholder-${shortName}`;
